import { FeedMode } from '@/types/models/Term.model'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { isNonEmptyObject } from '@/utils/checks'

export interface FilterOutSpecializationsByPrimaryFocusMapParams {
  specializations: string[]
  primaryFocusMap: Record<string, string> | null
  termFeedMode?: FeedMode
  primaryFocusToFilter?: PrimaryFocus
}

export const filterOutSpecializationsByPrimaryFocusMap = ({
  specializations,
  primaryFocusMap,
  termFeedMode = FeedMode.NONE,
  primaryFocusToFilter = PrimaryFocus.SUBSTANCE_USE
}: FilterOutSpecializationsByPrimaryFocusMapParams): string[] => {
  if (
    !isNonEmptyObject(primaryFocusMap) ||
    termFeedMode !== FeedMode.PRIMARY_FOCUS_STRICT
  ) {
    return specializations
  }
  return specializations.filter((specialization) => {
    return primaryFocusMap[specialization] !== primaryFocusToFilter
  })
}
